__turbopack_context__.v({
  "donny-spotlight-pulse": "jOzSdG_donny-spotlight-pulse",
  "liveRegion": "jOzSdG_liveRegion",
  "spotlightFrame": "jOzSdG_spotlightFrame",
  "spotlightFrameStatic": "jOzSdG_spotlightFrameStatic",
  "spotlightLayer": "jOzSdG_spotlightLayer",
});
